'use client'

import { useState } from 'react'
import ReCAPTCHA from 'react-google-recaptcha'


interface RecaptchaModalProps {
  isOpen: boolean
  onClose: () => void
  onVerify: (token: string) => void
  onError: () => void
}

const RecaptchaModal = ({ isOpen, onClose, onVerify, onError }: RecaptchaModalProps) => {
  const [isVerifying, setIsVerifying] = useState(false)

  const handleRecaptchaChange = async (token: string | null) => {
    if (token) {
      setIsVerifying(true)
      try {
        // Send token to your backend for verification
        const response = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/common/recaptcha/`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ recaptcha_token: token }),
        })

        const data = await response.json()

        if (response.ok && data.success === true) {
          onVerify(token)
        } else {
          console.error('reCAPTCHA verification failed:', data.message || 'Invalid reCAPTCHA')
          onError()
        }
      } catch (error) {
        console.error('reCAPTCHA verification error:', error)
        onError()
      } finally {
        setIsVerifying(false)
      }
    }
  }

  const handleRecaptchaError = () => {
    onError()
  }

  if (!isOpen) return null

  return (
    <>
      {/* Backdrop */}
      <div 
        className="fixed inset-0 z-[200] bg-black bg-opacity-50 transition-opacity"
        onClick={onClose}
      />
      
      {/* Modal */}
      <div className="fixed left-1/2 top-1/2 z-[201] -translate-x-1/2 -translate-y-1/2 transform">
        {/* <div className="relative rounded-lg bg-white md:w-full w-fit p-6 shadow-xl"> */}
          {/* Close button */}
          {/* <button
            onClick={onClose}
            className="absolute right-3 top-3 rounded-full p-1 transition-colors hover:bg-gray-100"
            aria-label="Close"
          >
            <X className="h-5 w-5 text-gray-500" />
          </button> */}

          {/* Content */}
          <div className="flex flex-col items-center gap-4 pt-2">
            {/* <h2 className="text-xl font-semibold text-gray-800">Verify you're human</h2>
            <p className="text-center text-sm text-gray-600">
              Please complete the reCAPTCHA verification to continue
            </p> */}
            
            <div className="mt-10">
              <ReCAPTCHA
                sitekey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY!}
                onChange={handleRecaptchaChange}
                onErrored={handleRecaptchaError}
                onExpired={() => onError()}
                size="normal"
              />
            </div>

            {isVerifying && (
              <div className="flex items-center gap-2 text-sm text-gray-600">
                <div className="h-4 w-4 animate-spin rounded-full border-2 border-gray-300 border-t-[#F59405]" />
                Verifying...
              </div>
            )}
          </div>
        {/* </div> */}
      </div>
    </>
  )
}

export default RecaptchaModal